import { intercept, extendObservable, reaction } from 'mobx';
import i18n, { LANGS, WHITELIST_LANGS } from '../i18n.js';
import * as constants from '../appConstants';

class UIStore {
    constructor() {
        // We can't yet use decorators in CRA projects without ejecting. We're trying to avoid that so
        // for now use extendObservable() until we can use @observable's when defining class properties
        extendObservable(this, {
            language: LANGS.EN_US,
            isLoading: false,
            isDrawerOpen: true,
            activeMap: constants.NORTH_AMERICA,
            selectedFilter: constants.FILTER_ALL,
            selectedState: null,
            screensaverActive: true,
        });

        /**
         * Ensure that whatever value language is being set to is in WHITELIST_LANGS
         */
        intercept(this, 'language', change => {
            // Don't allow for language to be set to a false-y value
            if (!change.newValue) { return null; }
            if (WHITELIST_LANGS.indexOf(change.newValue) < 0) {
                throw new Error(
                    'Attempted to set language to an unsupported language code:',
                    change.newValue
                );
            }
            return change;
        });

        /**
         * Reactions to changes to store values
         */
        // Update i18n with the current language
        reaction(() => this.language, lang => i18n.changeLanguage(lang));
    }
}

export default UIStore;
